<template>
  <b-sidebar bg-variant="white" id="help-sidebar" no-header right shadow>
    <i class="fas fa-close position-absolute" v-b-toggle.help-sidebar id="close"></i>
    <div class="px-3 py-2 mt-5">
      <h2 class="text-center mb-3">Help Menu</h2>
      <div>
        <b-list-group>
          <b-list-group-item class="text-danger" href="https://www.claritynowre.com/help" target="_blank"><i class="fas fa-question-circle"></i> Help Center</b-list-group-item>
          <b-list-group-item class="text-danger" href="https://us06web.zoom.us/meeting/register/tZwuf-GuqD8jEtPOlB3yeblIQMyYhzUJT5Xp" target="_blank"><i class="fas fa-users"></i> Weekly Training</b-list-group-item>
          <b-list-group-item class="text-danger" href="https://us06web.zoom.us/meeting/register/tZMufuuhrzojE9FKrAOJOGBC5WTAFU9HdF5s" target="_blank"><i class="fas fa-calendar"></i> Schedule a Call</b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
export default {

};
</script>

<style lang="scss">
#help-sidebar {
  #close {
    left: 10px;
    top: 10px;
  }
  .text-help {
    font-size: 15px;

    &:hover {
      background-color: #fcfcfc;
      cursor: pointer;
    }
  }
}
</style>